import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';

import noImage from 'assets/images/no-image.png';
import noImageSquare from 'assets/images/no-image-square.png';

const useStyles = makeStyles((theme) => ({
  Image: {
    maxWidth: '100%',
  },
}));

const Image = ({ src, className, square, alt, ...props }) => {
  const [isError, setError] = useState(false);
  const classes = useStyles();

  return (
    <img
      src={isError || !src ? (square ? noImageSquare : noImage) : src}
      onError={() => setError(true)}
      className={classNames(classes.Image, className, { Error: isError })}
      alt={alt || src || 'No image'}
      {...props}
    />
  );
};

Image.propTypes = {
  src: PropTypes.string,
  classNames: PropTypes.string,
  square: PropTypes.bool,
};

export default Image;
